<app-lib-inner-scrollable [pinFooter]="true">
  <ng-template templateFor="header">
    <app-header></app-header>
  </ng-template>
  <div
    #wizard
    class="wizard flex flex-col relative sz-{{screenSize()}}"
    ngClass.gt-xs="p-24"
    ngClass.lt-sm="p-12">

    <div fxLayout="row" gap="8" row-gap="8" fxFlex fxLayoutAlign="space-between start">
      @if (navSvc.backLinkOrAction(); as backLinkOrAction) {
        @if (backLinkIsAction(backLinkOrAction)) {
          <button class="link text blend !absolute left-0 top-8 step-back arrow-left"
                  (click)="backLinkOrAction()"
                  type="button"
                  #backBtn
                  style="color: var(--color-primary-primary);">
            <span style="font-weight: 500">Back</span>
          </button>
        } @else {
          <a class="link text blend !absolute left-0 top-8 step-back arrow-left"
             [routerLink]="backLinkOrAction"
             queryParamsHandling="merge"
             style="color: var(--color-primary-primary);">
            <span style="font-weight: 500">Back</span>
          </a>
        }
      } @else {
        <span>&nbsp;</span>
      }
      <span class="text-body-secondary"
            style="font-size: var(--size-16); line-height: calc(var(--size-16)* 1.5); align-content: center; text-align: end"
      >
            Need help scheduling an appointment? Call <a class="link blend pk_intake--need-help"
                                                         href="tel:+{{config.support.default}}">{{ config.support.default }}</a>.
          </span>
    </div>
    <div class="wizard-content grow section-{{navSvc.currentSection()}}  page-{{navSvc.currentPage()}}"
         ngClass.gt-xs="pt-24"
         ngClass.lt-sm="p-12">
        <router-outlet></router-outlet>
    </div>
  </div>

  <ng-content select="[slot='footer']"></ng-content>
  <ng-template templateFor="footer">
    <app-footer></app-footer>
  </ng-template>
</app-lib-inner-scrollable>
